import { render, staticRenderFns } from "./EmailMessages.vue?vue&type=template&id=15fca2c0&lang=pug"
import script from "./EmailMessages.vue?vue&type=script&lang=js"
export * from "./EmailMessages.vue?vue&type=script&lang=js"
import style0 from "./EmailMessages.vue?vue&type=style&index=0&id=15fca2c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports